// A favourite keeps a trimmed copy of the event so the list renders instantly
// and still shows something when the event is later delisted or the API is
// unreachable. Fresh data replaces it on every visit via /events/by-ids.
// Shared verbatim with mobile/utils/favouriteSnapshot.js.

import { parseEventDate } from './format';

const SNAPSHOT_FIELDS = [
  'title',
  'date',
  'venue',
  'address',
  'city',
  'country',
  'district',
  'event_type',
  'music_genre',
  'lowest_price',
  'image_url',
  'ticket_url',
  'tickets_available',
  'latitude',
  'longitude'
];

export function toSnapshot(event) {
  const snapshot = { _id: String(event._id) };
  for (const field of SNAPSHOT_FIELDS) {
    if (event[field] !== undefined) {
      snapshot[field] = event[field];
    }
  }
  return snapshot;
}

export function isPastEvent(event, now = new Date()) {
  const date = parseEventDate(event?.date);
  return Boolean(date) && date.getTime() < now.getTime();
}

// Merges freshly fetched events over the stored snapshots, keeping the saved
// order and flagging the ones the API no longer returns.
export function mergeFavourites(saved, fresh) {
  const byId = new Map(fresh.map((event) => [String(event._id), event]));

  return saved.map((entry) => {
    const current = byId.get(entry.id);
    return {
      id: entry.id,
      savedAt: entry.savedAt,
      event: current || entry.event,
      unavailable: !current
    };
  });
}
